const S3AccessKeyId = process.env.VUE_APP_S3_ACCESS_KEY_ID;
const S3SecretKey = process.env.VUE_APP_S3_SECRET_KEY;
const bucketName = process.env.VUE_APP_S3_BUCKET_NAME;

export { S3AccessKeyId, S3SecretKey, bucketName };
